<template>
  <div class="type-three">
    <h2 class="text-title">
      Construction Site Remote Support System<br />活用の流れ
    </h2>
    <p class="text-description font-18">
      会社ライセンス取得～現場単位でライセンス取得～支払いまで
    </p>
  </div>
</template>

<script>
export default {
  name: "TypeThree"
};
</script>

<style lang="sass" scoped>
.type-three
  text-align: center
  padding: 80px 12px
  background-color: #ffffff
  .text-title
    margin-bottom: 36px
    color: #0066E3
</style>
